import "./Schools.module.css";
import Navigation from "@/reusable_sections/Header";
import Intelligence from "./sections/Intelligence";
import Integration from "./sections/Integration";
import WhySchools from "./sections/WhySchools";
import Benefits from "./sections/Benefits";
import Footer from "@/reusable_sections/Footer";
export default function SchoolsPage() {
  return <div>
      <Navigation />
      <Intelligence />
      <Integration />
      <WhySchools />
      <Benefits />
      <Footer />
    </div>;
}